import React, { useState, useEffect } from "react";
import { Form } from "react-bootstrap";
import { Onboarding_Page } from "../../Configuration/API_URL";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import closeBtn from "../../asset/images/close.svg";
import { Constants } from "../../CommonMethhods/Constants";
// import errorImage from "../../asset/images/icons/errorImage.svg";
// import { Col, Row, Toast } from "react-bootstrap";
import {
  AESEncryption,
  ApiResDecrypt,
  compareDate,
} from "../../CommonMethhods/CommonMethods";
import moment from "moment";
import { toast } from "react-toastify";
import axiosInstance from "../../CommonMethhods/axiosInstance";

function Filter(props) {
  let tabStatus = props.tabStatus;
  let updateStatus = props.updateStatus;
  const [show, setShow] = useState(false);
  const [checkPan, setCheckPan] = useState("");
  const [checkKyc, setCheckKyc] = useState("");
  const [checkSource, setCheckSource] = useState("");
  const [checkCreatedDate, setCheckCreatedDate] = useState(null);
  const [checkUpdatedDate, setCheckUpdatedDate] = useState(null);
  const [checkReferralId, setCheckReferralId] = useState("");
  const [checkIsReferred, setCheckIsReferred] = useState(false);
  const [saveData, setSaveData] = useState();
  const [resetData, setResetData] = useState();
  const [createDate, setCreateDate] = useState("");
  const [updatedDate, setUpdatedDate] = useState("");
  const [checkDate, setCheckDate] = useState(false);
  const [updatedDateValue, setUpdatedDateValue] = useState(" ");
  const [createDateValue, setCreateDateValue] = useState(" ");

  const storeToken = localStorage.getItem("ssoToken");
  const handleShow = () => setShow(true);
  const handleClose = () => {
    setShow(false);
    setCheckPan("");
  };

  const filterData = async () => {
    handleClose();
    let payloadValue = {
      status: tabStatus,
      pan: checkPan,
      createdDate: checkCreatedDate == "" ? null : checkCreatedDate,
      updatedDate: checkUpdatedDate == "" ? null : checkUpdatedDate,
      kycStatus: checkKyc,
      source: checkSource,
      referralId: checkReferralId,
      isReferred: checkIsReferred,
    };
    let encPayload = AESEncryption(payloadValue);
    try {
      const getDetail = await axiosInstance.post(
        Onboarding_Page.OnboardingFilter_URL,

        `"${encPayload}"`,
      );
      const res = ApiResDecrypt(getDetail?.data);

      props.updateStatus(res?.data);
    } catch (error) {
      console.log(error);
    }
  };

  const saveFilterSearch = async () => {
    handleClose();
    let payloadValue = {
      status: tabStatus,
      pan: checkPan,
      createdDate: checkCreatedDate == "" ? null : checkCreatedDate,
      updatedDate: checkUpdatedDate == "" ? null : checkUpdatedDate,
      kycStatus: checkKyc,
      source: checkSource,
      referralId: checkReferralId,
      isReferred: checkIsReferred,
    };
    let encPayload = AESEncryption(payloadValue);

    try {
      const saveDetail = await axiosInstance.post(
        Onboarding_Page.OnboardingSaveFilterSearch_URL,
        `"${encPayload}"`,
      );
      const saveResponse = ApiResDecrypt(saveDetail?.data);
      setSaveData(saveResponse.data);
    } catch (error) {
      console.log(error);
    }
  };

  const getFilterSearch = async () => {
    let payloadValue = {};
    let encPayload = AESEncryption(payloadValue);
    try {
      const getFilterSearchDetail = await axiosInstance.post(
        Onboarding_Page.OnboardingGetFilterSearch_URL,
        `"${encPayload}"`,
      );
      const res = ApiResDecrypt(getFilterSearchDetail?.data);

      const getSavedResponse = res.data;
      setCheckPan(getSavedResponse.pan);
      // setCheckCreatedDate(getSavedResponse.createddate);
      // setCheckUpdatedDate(getSavedResponse.updateddate);
      setCheckKyc(getSavedResponse.kycstatus);
      setCheckSource(getSavedResponse.source);
      setCheckReferralId(getSavedResponse.referralid);
      if (getSavedResponse.isreferred == "1") {
        setCheckIsReferred(true);
      } else {
        setCheckIsReferred(false);
      }
      if (getSavedResponse.createddate == "") {
        setCheckCreatedDate(null);
      } else {
        setCheckCreatedDate(getSavedResponse.createddate);
      }
      if (getSavedResponse.updateddate == "") {
        setCheckUpdatedDate(null);
      } else {
        setCheckUpdatedDate(getSavedResponse.updateddate);
      }
      handleShow();
    } catch (error) {
      console.log(error);
    }
  };

  const resetFilter = async () => {
    let payloadValue = {};
    let encPayload = AESEncryption(payloadValue);
    try {
      const resetDetail = await axiosInstance.post(
        Onboarding_Page.OnboardingResetFilter_URL,

        `"${encPayload}"`,
      );
      const res = ApiResDecrypt(resetDetail?.data);
      const resetResponse = res.data;
      setResetData(resetResponse);
      if (resetResponse == "Data is reset") {
        setCheckPan("");
        setCheckCreatedDate("");
        setCheckUpdatedDate("");
        setCheckKyc("");
        setCheckSource("");
        setCheckReferralId("");
        setCheckIsReferred(false);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const checkPanHandle = (e) => {
    if (e.target.value) {
      let result = e.target.value.toUpperCase();
      setCheckPan(result);
    } else {
      setCheckPan("");
    }
  };

  const kycStatusHandler = (e) => {
    if (e.target.value) {
      setCheckKyc(e.target.value);
    }
  };

  const sourceHandler = (e) => {
    if (e.target.value) {
      setCheckSource(e.target.value);
    }
  };

  const createdDateHandler = (e) => {
    if (e.target.value) {
      if (compareDate(createDate)) {
      } else {
        setCheckDate(true);
        toast.error("Please Select Correct Date.");
      }
    }
  };

  const onChangeCreate = (e) => {
    setCheckCreatedDate(e.target.value);
    let c = e.target.value;
    setCreateDateValue(c);
    const d = moment(c, "YYYY-MM-DD").format("MM-DD-YYYY");
    setCreateDate(d);
  };

  const updatedDateHandler = (e) => {
    if (e.target.value) {
      if (compareDate(updatedDate)) {
      } else {
        setCheckDate(true);
      }
    }
  };

  const onChangeUpdated = (e) => {
    setCheckUpdatedDate(e.target.value);
    let c = e.target.value;
    setUpdatedDateValue(c);
    const d = moment(c, "YYYY-MM-DD").format("MM-DD-YYYY");
    setUpdatedDate(d);
  };

  const referralIdHandler = (e) => {
    if (e.target.value) {
      setCheckReferralId(e.target.value);
    }
  };

  const isReferredHandler = (e) => {
    if (e.target.value) {
      setCheckIsReferred(e.target.value);
      setCheckIsReferred(true);
    }
  };

  const currentDate = new Date();
  const yyyy = currentDate.getFullYear();
  let mm = currentDate.getMonth() + 1;
  let dd = currentDate.getDate();
  if (dd < 10) dd = "0" + dd;
  if (mm < 10) mm = "0" + mm;
  const FormatedDate = dd + "/" + mm + "/" + yyyy;
  const DateReverse = FormatedDate.split("/").reverse().join("-");

  return (
    <>
      <Button variant="primary" onClick={getFilterSearch}>
        {Constants.Filter}
      </Button>
      <Modal
        show={show}
        onHide={handleClose}
        className="onboarding-popup-wrapper"
        backdrop="static"
        keyboard={false}
        centered
      >
        <Modal.Header>
          <Modal.Title>{Constants.Filters}</Modal.Title>
          <button
            type="button"
            onClick={handleClose}
            className="btn-close filter-closeBtn"
            aria-label="Close"
          >
            {/* <img src={closeBtn} alt="X" /> */}
            <span className="icon-close"></span>
          </button>
        </Modal.Header>{" "}
        <Modal.Body>
          <Form>
            <div className="row">
              <div className="col-md-4 col-sm-6 col-12">
                <Form.Group
                  className="form-group"
                  controlId="formBasicPassword"
                >
                  <Form.Label>{Constants.PAN}</Form.Label>
                  <Form.Control
                    type="text"
                    value={checkPan}
                    placeholder="Enter PAN Number"
                    onChange={checkPanHandle}
                  />
                </Form.Group>
              </div>
              <div className="col-md-4 col-sm-6 col-12">
                <Form.Group
                  className="form-group"
                  controlId="formBasicPassword"
                >
                  <Form.Label>{Constants.Date_Range}</Form.Label>
                  <Form.Control
                    type="date"
                    className="date-btn"
                    placeholder="DD/MM/YYYY"
                    onfocus="(this.type='date')"
                    defaultValue={checkCreatedDate}
                    onBlur={createdDateHandler}
                    onChange={onChangeCreate}
                    max={DateReverse}
                  />
                </Form.Group>
              </div>
              <div className="col-md-4 col-sm-6 col-12">
                <Form.Group
                  className="form-group"
                  controlId="formBasicPassword"
                >
                  <Form.Label>{Constants.Updated_Date_Range}</Form.Label>
                  <Form.Control
                    type="date"
                    className="date-btn"
                    placeholder="DD/MM/YYYY"
                    defaultValue={checkUpdatedDate}
                    onBlur={updatedDateHandler}
                    onChange={onChangeUpdated}
                    max={DateReverse}
                  />
                </Form.Group>
              </div>
              <div className="col-md-4 col-sm-6 col-12">
                <Form.Group
                  className="form-group"
                  controlId="formBasicPassword"
                >
                  <Form.Label>{Constants.OnBoarding_Date}</Form.Label>
                  <Form.Control
                    type="date"
                    className="date-btn"
                    placeholder="Date Range Picker"
                    disabled
                  />
                </Form.Group>
              </div>
              {/* <div className="col-md-4 col-sm-6 col-12">
                                <Form.Group
                                    className="form-group"
                                    controlId="formBasicPassword"
                                >
                                    <Form.Label>Updated Date Range</Form.Label>
                                    <Form.Control type="date" className="date-btn" placeholder="Date Range Picker" disabled />
                                </Form.Group>
                            </div> */}
              <div className="col-md-4 col-sm-6 col-12">
                <div className="form-group">
                  <Form.Label>{Constants.KYC_Status}</Form.Label>
                  <div className="call-status">
                    <Form.Select
                      aria-label="Default select example"
                      className="select"
                      onChange={kycStatusHandler}
                      value={checkKyc}
                    >
                      <option>{Constants.Unable_Connect}</option>
                      <option value="1">{Constants.Verified}</option>
                      <option value="2">{Constants.Not_Verified}</option>
                    </Form.Select>
                  </div>
                </div>
              </div>
              <div className="col-md-4 col-sm-6 col-12">
                <div className="form-group">
                  <Form.Label>{Constants.Comments}</Form.Label>
                  <div className="call-status">
                    <Form.Select
                      aria-label="Default select example"
                      className="select"
                      disabled
                    >
                      <option>{Constants.Unable_Connect}</option>
                      <option value="1">{Constants.One}</option>
                      <option value="2">{Constants.Two}</option>
                    </Form.Select>
                  </div>
                </div>
              </div>
              <div className="col-md-4 col-sm-6 col-12">
                <div className="form-group">
                  <Form.Label>{Constants.Calling_Status}</Form.Label>

                  <div className="call-status">
                    <Form.Select
                      aria-label="Default select example"
                      className="select"
                      disabled
                    >
                      <option>{Constants.Unable_Connect}</option>
                      <option value="1">{Constants.One}</option>
                      <option value="2">{Constants.Two}</option>
                      <option value="3">{Constants.Three}</option>
                    </Form.Select>
                  </div>
                </div>
              </div>
              <div className="col-md-4 col-sm-6 col-12">
                <div className="form-group">
                  <Form.Label>{Constants.Lead_Status}</Form.Label>
                  <div className="call-status">
                    <Form.Select
                      aria-label="Default select example"
                      className="select"
                      disabled
                    >
                      <option>{Constants.Unable_Connect}</option>
                      <option value="1">{Constants.One}</option>
                      <option value="2">{Constants.Two}</option>
                      <option value="3">{Constants.Three}</option>
                    </Form.Select>
                  </div>
                </div>
              </div>
              <div className="col-md-4 col-sm-6 col-12">
                <div className="form-group">
                  <Form.Label>{Constants.Assignee}</Form.Label>
                  <div className="call-status">
                    <Form.Select
                      aria-label="Default select example"
                      className="select"
                      disabled
                    >
                      <option>{Constants.Unable_Connect}</option>
                      <option value="1">{Constants.One}</option>
                      <option value="2">{Constants.Two}</option>
                      <option value="3">{Constants.Three}</option>
                    </Form.Select>
                  </div>
                </div>
              </div>
              <div className="col-md-4 col-sm-6 col-12">
                <div className="form-group">
                  <Form.Label>{Constants.Source}</Form.Label>
                  <div className="call-status">
                    <Form.Select
                      aria-label="Default select example"
                      className="select"
                      onChange={sourceHandler}
                      value={checkSource}
                    >
                      <option>{Constants.Select_Source}</option>
                      <option value="1">{Constants.Ekyc}</option>
                      <option value="2">{Constants.Samadhan}</option>
                    </Form.Select>
                  </div>
                </div>
              </div>
              <div className="col-md-4 col-sm-6 col-12">
                <div className="form-group">
                  <Form.Label>{Constants.Device}</Form.Label>
                  <div className="call-status">
                    <Form.Select
                      aria-label="Default select example"
                      className="select"
                      disabled
                    >
                      <option>{Constants.Select_Device}</option>
                      <option value="1">{Constants.One}</option>
                      <option value="2">{Constants.Two}</option>
                      <option value="3">{Constants.Three}</option>
                    </Form.Select>
                  </div>
                </div>
              </div>
              <div className="col-md-4 col-sm-6 col-12">
                <Form.Group
                  className="form-group"
                  controlId="formBasicPassword"
                >
                  <Form.Label>{Constants.Referral_ID}</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter Referral ID"
                    defaultValue={checkReferralId}
                    onChange={referralIdHandler}
                  />
                </Form.Group>
              </div>
              <div className="col-md-4 col-sm-6 col-12">
                <div className="form-group">
                  <Form.Label>{Constants.Is_Referred}</Form.Label>
                  <div className="call-status">
                    <Form.Select
                      aria-label="Default select example"
                      className="select"
                      defaultValue={checkIsReferred}
                      onChange={isReferredHandler}
                    >
                      <option>{Constants.Select_Is_Referred}</option>
                      <option value="true">{Constants.Yes}</option>
                      <option value="false">{Constants.No}</option>
                    </Form.Select>
                  </div>
                </div>
              </div>
              <div className="col-md-4 col-sm-6 col-12">
                <div className="form-group">
                  <Form.Label>{Constants.Screen_Identifier}</Form.Label>
                  <div className="call-status">
                    <Form.Select
                      aria-label="Default select example"
                      className="select"
                      disabled
                    >
                      <option>{Constants.Select_Screen_Identifier}</option>
                      <option value="1">{Constants.One}</option>
                      <option value="2">{Constants.Two}</option>
                      <option value="3">{Constants.Three}</option>
                    </Form.Select>
                  </div>
                </div>
              </div>
            </div>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <input
            type="submit"
            value="Submit"
            className="filter filter-submit"
            onClick={filterData}
          />
          <input
            type="reset"
            value="Reset"
            className="filter filter-reset"
            onClick={resetFilter}
          />
          <input
            type="submit"
            value="Save as Filter"
            className="filter filter-save"
            onClick={saveFilterSearch}
          />
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default Filter;
